import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-8 lg:mt-16 w-full" }

import { ref, computed } from 'vue';
import PatientData from '../shared/PatientData.vue';
import ImportantInformationField from '../shared/Fields/ImportantInformationField.vue';
import ProductForm from '../shared/ProductForm.vue';
import { initialValues } from './initialValues';
import { schema } from './schema';
import DateOfLastMenstruationField from '../shared/Fields/DateOfLastMenstruationField.vue';
import LastUnprotectedSexField from '../shared/Fields/LastUnprotectedSexField.vue';
import LastVisitDoctorField from '../shared/Fields/LastVisitDoctorField.vue';
import AdditionalDiseasesField from '../shared/Fields/AdditionalDiseasesField.vue';
import ContraceptionMedicineField from '../shared/Fields/ContraceptionMedicineField.vue';
import UploadedFileField from '../shared/Fields/UploadedFileField.vue';
import VariationsField from '../shared/Fields/VariationsField.vue';
import Terms from '../shared/Terms.vue';


export default {
  __name: 'Tabletka',
  props: {
    checkoutlink: { type: String, required: true },
    price: {
        type: String,
        required: true,
    },
    id: {
        type: Number,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    shortdescription: {
        type: String,
        required: true,
    },
    customer: {
        type: String,
        required: false,
    },
    variations: {
        type: String,
        required: false,
    },
    variantname: {
        type: String,
        required: false,
    },
},
  setup(__props) {

const props = __props;



const customerData = JSON.parse(props.customer || '{}');

const variationsData = JSON.parse(props.variations || []);
const selectedVariation = ref(variationsData[0]?.variation_id);

const selectVariation = (variationId) => {
    selectedVariation.value = variationId;
};

const values = computed(() => initialValues(customerData));

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(ProductForm, {
    schema: _unref(schema),
    initialValues: _unref(values),
    id: __props.id,
    checkoutlink: __props.checkoutlink,
    price: __props.price,
    title: __props.title,
    shortdescription: __props.shortdescription,
    variations: _unref(variationsData),
    selectedVariation: selectedVariation.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ContraceptionMedicineField),
        _createVNode(DateOfLastMenstruationField),
        _createVNode(LastUnprotectedSexField),
        _createVNode(LastVisitDoctorField),
        _createVNode(AdditionalDiseasesField, {
          title: "Czy choruje Pani na choroby przewklekłe lub posiada alergie na jakiekolwiek Ieki?",
          isRequired: false
        }),
        _createVNode(ImportantInformationField, {
          isRequired: false,
          title: "Dodatkowe informacje",
          placeholder: "W razie potrzeby możesz przekazać Iekаrzowi dodatkowe, istotne informacje."
        }),
        _createVNode(UploadedFileField)
      ]),
      _createVNode(PatientData),
      _createVNode(VariationsField, {
        name: __props.variantname,
        variations: _unref(variationsData),
        selectedVariation: selectedVariation.value,
        selectVariation: selectVariation
      }, null, 8, ["name", "variations", "selectedVariation"]),
      _createVNode(Terms)
    ]),
    _: 1
  }, 8, ["schema", "initialValues", "id", "checkoutlink", "price", "title", "shortdescription", "variations", "selectedVariation"]))
}
}

}